<div class="message sam-full-width sam-ellipsis-on-overflow" *ngIf="message">
   <span class="participant">
      <span *ngIf="message.sender === chatParticipantType.Agent">{{
         'samwin.chat_dialog.peer_type.agent' | translate
      }}</span>
      <span *ngIf="message.sender === chatParticipantType.Peer">{{
         'samwin.chat_dialog.peer_type.peer' | translate
      }}</span>
      <span *ngIf="message.sender === chatParticipantType.Bot">{{
         'samwin.chat_dialog.peer_type.bot' | translate
      }}</span>
   </span>
   <span>: </span>
   <span>{{ message.text }}</span>
</div>
